import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact'
import { useCallback, useEffect } from 'preact/hooks';

import Breadcrumbs from '../components/Breadcrumbs'
import Sorting from '../components/Sorting'
import NoResults from '../components/NoResults'
import Products from '../components/Products'
import Sidebar from '../components/Sidebar'
import SidebarToolbar from '../components/SidebarToolbar'
import BottomToolbar from '../components/BottomToolbar'
import PlaceholdersList from '../components/PlaceholdersList'

export default () => {
    const { response: { products }, loading } = useAppState();
    const foundProducts = products && products.total > 0;

    const { customer, nosto, collection } = window.cj || {}
    const isAuthenticated = !!customer?.email;
    const isLoginModelEnabled = nosto?.loginModelEnabled
    const shouldShowContactSellerBtn = collection?.type === 'Store'

    useEffect(() => {
        if (loading == false) {
            // re-init yotpo stars Product.jsx
            yotpoWidgetsContainer.initWidgets(345477);
            // TODO: Is there a simlilar function for wishlisting?
        }
    }, [loading]);

    const openContactSellerModal = useCallback(() => {
        const contactSellerForm = window.contactSellerForm;
        if (!contactSellerForm || !foundProducts) return;

        const product = products.hits[0]
        contactSellerForm.reset();
        contactSellerForm.popupToggle();

        const backdrop = document.getElementById('modal');
        const contactForm = document.getElementById('pdp-contact-seller');
        const closeButton = document.getElementById('pdp-contact-seller-form-close-btn');

        const toggleContactSellerModal = () => {
            if (contactForm?.classList.contains('active'))
                contactSellerForm.popupToggle();
        };

        backdrop?.addEventListener('click', toggleContactSellerModal);
        closeButton?.addEventListener('click', toggleContactSellerModal);

        contactForm?.addEventListener('submit', (e) => {
            e.preventDefault();
            const formData = new FormData(contactForm);
            const data = formData.entries().reduce((acc, [key, value]) => { acc[key] = value?.trim() || ''; return acc }, {});
            const productId = product.productId;
            const productSlug = product.url.split('/').pop();
            contactSellerForm.submit(productId, productSlug, data);
        });
    }, [foundProducts, products]);

    const handleOnClickContactSeller = useCallback(() => {
        if (isAuthenticated)
            openContactSellerModal()
        else {
            if (isLoginModelEnabled) {
                // open the login model
                const loginPopup = window.loginPopup;
                if (loginPopup) {
                    loginPopup.signInForm('contact-seller');
                    loginPopup.popupToggle();
                    window.scrollTo(0, 0);
                }
            } else window.location.href = 'account/login'

        }
    }, [openContactSellerModal])

    useEffect(() => {
        if (loading) return
        const urlParams = new URLSearchParams(window.location.search);
        const shouldOpenContactSellerModal = urlParams.get('action') === 'pdp-contact-seller-open';

        if (shouldOpenContactSellerModal) {
            handleOnClickContactSeller();
            urlParams.delete('action');
            const newUrl = `${window.location.pathname}${urlParams.toString() ? `?${urlParams.toString()}` : ''}`;
            window.history.replaceState(null, '', newUrl);
        }
    }, [handleOnClickContactSeller, loading]);

    return (
        <>
            {/* TODO: Breadcrumb to be updated in https://cratejoy.atlassian.net/browse/CS-703 */}
            {/* <div className='collection-breadcrumb-bg maxw'>
                <Breadcrumbs isCategorySelected={false} />
            </div> */}
            <div class="plp-top-info mt-4">
            </div>
            {shouldShowContactSellerBtn && foundProducts && !loading && <div class='w-full px-4 mt-4 lg:hidden '> <button
                type='button'
                class="btn-primary flex items-center justify-center gap-2 w-full text-center m-auto border border-gray-300 rounded-md text-black hover:bg-gray-50 text-sm py-2 px-4"
                data-app-contact-seller-open
                onClick={handleOnClickContactSeller}
            >
                <svg width={24} version="1.1" x="0px" y="0px" viewBox="0 0 100 100">
                    <g transform="translate(0,-952.36218)">
                        <path style="text-indent:0;text-transform:none;direction:ltr;block-progression:tb;baseline-shift:baseline;color:#000000;enable-background:accumulate;"
                            d="m 16,973.36218 c -4.4385,0 -7.9999999,3.7333 -7.9999999,8.2188 l 0,41.53122 c 0,4.4854 3.5614999,8.25 7.9999999,8.25 l 68,0 c 4.4387,0 8,-3.7646 8,-8.25 l 0,-41.53122 c 0,-4.4855 -3.5613,-8.2188 -8,-8.2188 l -68,0 z m 0,4 68,0 c 0.5867,0 1.1544,0.1432 1.6563,0.375 L 52.5938,1008.331 c -1.5276,1.4131 -3.5634,1.4133 -5.0938,0 L 14.375,977.73718 c 0.4955,-0.2245 1.0481,-0.375 1.625,-0.375 z m -3.9374,3.6875 23.4687,21.68752 -23.0313,22.4062 c -0.3039,-0.6003 -0.5,-1.2807 -0.5,-2.0312 l 0,-41.53122 c 0,-0.1838 0.043,-0.3552 0.063,-0.5313 z m 75.875,0.031 c 0.018,0.1662 0.062,0.3269 0.062,0.5 l 0,41.53122 c 0,0.7348 -0.1765,1.4084 -0.4687,2 l -22.9687,-22.4062 23.375,-21.62502 z m -26.2813,24.31242 22.4687,21.9688 c -0.042,0 -0.083,0 -0.125,0 l -68,0 c -0.032,0 -0.062,7e-4 -0.094,0 l 22.5625,-21.9375 6.3125,5.8437 c 2.9675,2.7408 7.5644,2.7446 10.5313,0 l 6.3437,-5.875 z"
                            fill="#000000" fill-opacity="1" stroke="none" marker="none" visibility="visible" display="inline" overflow="visible" />
                    </g>
                </svg>
                Contact Seller
            </button>
            </div>
            }
            <div id="plp-container" className='collections-container'>
                {loading ? (
                    <PlaceholdersList />
                ) : (
                    <>
                        <div id="plp-sidebar" class="mobile-sticky">
                            <div className="mt-4">
                                <Sidebar isCategorySelected={true} handleOnClickContactSeller={shouldShowContactSellerBtn && handleOnClickContactSeller} />
                                <hr class="sticky-break" />
                            </div>
                        </div>
                        {foundProducts ?
                            <div id="plp-main-collection-products">
                                <Products />
                                <BottomToolbar />
                            </div>
                            :
                            (
                                <NoResults />
                            )
                        }
                    </>
                )}
            </div>
        </>
    )
}
